import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

const user = JSON.parse(localStorage.getItem('user'));


const getDealerbyid = async () => {
  const response = await axios.get(API_URL + `api/dealers/dealer/${user.dealer_id}`, { headers: authHeader() });
  return response.data;
};

const updateDealer = async (dealer_id, formData) => {
  const response = await axios.put(API_URL + `api/dealers/${dealer_id}`, {...formData}, { headers: authHeader() });
  return response.data;
};

const dealerService = {
  getDealerbyid,
  updateDealer,
};

export default dealerService